import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import './index.scss';

const SubTabComponent = ({ onMainTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="sub-tab-component no-select">
      <div className="main">
        <div className="title">
          {t('You are opening this application on another Tab')}
        </div>
        <div className="content">
          <div className="text">{t('Click activate to use on this Tab')}</div>
          <div className="button">
            <Button onClick={() => onMainTabChange()}>{t('Activate')}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubTabComponent;
